// extracted by mini-css-extract-plugin
export var emailBlockLink = "_oy-0";